import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SocialGoogleIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.04 12.2614C23.04 11.4459 22.9668 10.6618 22.8309 9.90909H12V14.3575H18.1891C17.9225 15.795 17.1123 17.013 15.8943 17.8284V20.7139H19.6109C21.7855 18.7118 23.04 15.7636 23.04 12.2614Z"
				fill="#4285F4"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9999 23.4998C15.1049 23.4998 17.7082 22.4702 19.6109 20.7139L15.8943 17.8284C14.8645 18.5184 13.5472 18.926 11.9999 18.926C9.00469 18.926 6.46946 16.903 5.56515 14.1848H1.7231V17.1644C3.61537 20.9228 7.50446 23.4998 11.9999 23.4998Z"
				fill="#34A853"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.56515 14.1848C5.33515 13.4948 5.20455 12.758 5.20455 12.0001C5.20455 11.2421 5.33523 10.5051 5.56523 9.81506V6.83552H1.72318C0.944318 8.38802 0.5 10.1444 0.5 12.0001C0.5 13.8557 0.944237 15.6119 1.7231 17.1644L5.56515 14.1848Z"
				fill="#FBBC05"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9999 5.07386C13.6883 5.07386 15.2042 5.65409 16.3961 6.79364L19.6945 3.49523C17.7029 1.63955 15.0997 0.5 11.9999 0.5C7.50447 0.5 3.61545 3.07711 1.72318 6.83552L5.56523 9.81506C6.46955 7.09688 9.00469 5.07386 11.9999 5.07386Z"
				fill="#EA4335"
			/>
		</svg>
	);
}

SocialGoogleIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SocialGoogleIcon;
